

































import { Vue, Prop } from 'vue-property-decorator';
import { Component, Mixin, Mixins } from 'vue-mixin-decorator';
import { GithubUser } from '@/models/github-user';
import { vxm } from '@/store';

@Component
export default class Profile extends Vue {
  @Prop({ required: true })
  public user!: GithubUser;

  private get Config() {
    return vxm.config.cfg;
  }

  private get repoUrl() {
    if (this.user && this.user.login) {
      return `https://github.com/${this.user.login}`;
    }
  }
}
